import { useSelector } from 'react-redux';

import { getFlightAmenities } from '@apis/flight';

import { useAxiosQuery, UseAxiosQueryOptions } from '@hooks/useAxiosQuery';

import { getLocaleState } from '@redux/selectors';

export const getFlightAmenitiesKey = 'flight-amenities';

type GetFlightAmenitiesParams = {
  tripId: string;
};

export const useGetFlightAmenities = (
  params: GetFlightAmenitiesParams,
  options: UseAxiosQueryOptions<FlightAmenities>,
) => {
  const locale = useSelector(getLocaleState);

  return useAxiosQuery({
    queryKey: [getFlightAmenitiesKey, { locale, ...params }],
    queryFn: () => getFlightAmenities(params.tripId, locale),
    staleTime: 1000 * 60 * 30, // 30 minutes
    ...options,
  });
};
